export default {
    methods: {
        /**
        * Select the previous page.
        */
        selectPreviousPage() {
            this.updateQueryString({ ['page']: this.currentPage - 1 })
        },

        /**
        * Select the next page.
        */
        selectNextPage() {
            this.updateQueryString({ ['page']: this.currentPage + 1 })
        },
    },

    computed: {
        /**
        * Get the current page from the query string.
        */
        currentPage() {
            return parseInt(this.$route.query['page'] || 1)
        },
    },
}


// WEBPACK FOOTER //
// ./src/mixins/paginatable.js